import { Box, colors, IconButton } from '@mui/material'
import { useContext } from 'react'
import { FaEthereum } from 'react-icons/fa'

import { EthersContext } from '../Contexts'

const EthIcon: React.FC = () => {
  const { signer, provider, providerName, connect } = useContext(EthersContext)
  const ethIconColor =
    signer === undefined && provider === undefined ? colors.grey[500] : signer ? colors.green[500] : provider ? colors.yellow[500] : colors.red[500]
  const ethIconHint =
    signer === undefined && provider === undefined
      ? 'Connecting...'
      : signer
      ? `Connected (Full) - ${providerName}`
      : provider
      ? `Connected (Readonly) - ${providerName}`
      : 'Not Connected'

  const onClick = async () => {
    await connect?.()
  }

  return (
    <Box alignItems="center" display="flex" justifyContent="center">
      <IconButton onClick={onClick} style={{ padding: '6px' }} title={ethIconHint}>
        <FaEthereum color={ethIconColor} />
      </IconButton>
    </Box>
  )
}

export default EthIcon
